import { DetectMobile } from "../../../mixins/detectmobile";
import { defaultCommonStyles } from "../../../api/constants/colors";

export default {
  state: {
    activePopup: false,
  },
  mutations: {
    setActivePopupState(state, payload) {
      state.activePopup = payload;
    },
  },
  getters: {
    mobileStyles(state, getters, roostate) {
      var styles = roostate.store.ViewConfig ? roostate.store.ViewConfig.UiColours.Mobile : {};
      const colors = roostate.store.storeDoc ? roostate.store.storeDoc.ViewComponentConfigs.UiColours.Mobile : {};
      const menuCategoriesBackground = colors.MenuTabBackground
          ? colors.MenuTabBackground
          : colors.MenuBackground
              ? colors.MenuBackground
              : "#ffffff";

      return {
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`,
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`,
        },
        LinkColorTxt: {
          color: `#0000dd !important`,
        },
        btn: {
          // background: styles.ButtonColour,
          border: 0,
          // color: styles.ButtonText,
        },

        sushiBtn: {
          borderRadius : '10px'
        },
        mobilePlaceOrderButton: {
          borderRadius: '4px',
          lineHeight: '21px',
          fontSize: '16px',
          fontWeight: '600',
        },
        alertInfoBackGround: {
          background: styles.CommonColor,
        },
        TitleBar: {
          "background-color": `${styles.TitleBar} !important`,
        },
        TitleBarSushi: {
          "background-color": `#212121 !important`,
        },
        TitleBarBorderColor: {
          "border-bottom": `14px solid ${styles.TitleBar} !important`,
        },
        nav: {
          "background-color": `${menuCategoriesBackground} !important`,
        },
        navText: {
          color: styles.MenuText,
        },
        menu: {
          "background-color": `${colors.MenuBackground} !important`,
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`,
          "border-bottom": `3px solid ${styles.MenuHighlight}`,
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        primaryBodyBackground: {
          "background-color": `#eeeeee !important`,
        },
        menuItemColor: {
          color: `${styles.CommonColor} !important`,
        },
        primaryBackgroundColour: {
          "background-color": `#eeeeee !important`,
        },
        primaryColour: {
          color: `#212529`,
        },
        primaryColourImportant: {
          color: `#212529 !important`,
        },
        primaryColourSushiImportant: {
          color: `#2E2E2E !important`,
        },

        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`,
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`,
        },
        successMsg: {
          color: `#4CAF50`,
          "border-color": `#4CAF50`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
          margin: "0.5rem",
          padding: "0.3rem",
        },
        roolIntoButton: {
          color: "#ffffff",
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".1rem",
          margin: "0.5rem",
          padding: "0.3rem",
          background: "#0275d8",
          width: "96%",
        },
        primaryColor: {
          color: "#ffffff",
        },
        stepProgressBarBeforeCommonColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `#212529`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `#212529`,
          "border-radius": "50%",
        },
        stepProgressBarBeforePendingColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `#ededed`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `#ededed`,
          "border-radius": "50%",
        },
        stepProgressBarAfterCommonColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `#212529`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1",
        },
        stepProgressBarAfterPendingColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `#ededed`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1",
        },
        splashScreenTextColor: {
          color: `${styles.SplashScreenTextColor}`,
        },
      };
    },
    mobileColours(state, getters, roostate) {
      return roostate.store.ViewConfig.UiColours.Mobile;
    },
    desktopStyles(state, getters, roostate) {
      var styles = roostate.store.ViewConfig ? roostate.store.ViewConfig.UiColours.Desktop : {};
      const colors = roostate.store.storeDoc ? roostate.store.storeDoc.ViewComponentConfigs.UiColours.Desktop : {};
      const menuCategoriesBackground = colors.MenuTabBackground
          ? colors.MenuTabBackground
          : colors.MenuBackground
              ? colors.MenuBackground
              : "#ffffff";
      const menuBackgroundImage = roostate.store.storeDoc ? roostate.store.storeDoc.ViewComponentConfigs.MenuBackgroundImage : null;
      const MenuBackgroundString = `${colors.MenuBackground ? colors.MenuBackground : ''}${menuBackgroundImage ? " url('".concat(menuBackgroundImage, "') no-repeat center center fixed") : ''}${colors.MenuBackground || menuBackgroundImage ? ' !important' : ''}`;

      return {
        btn: {
          background: styles.ButtonColour,
          border: 0,
          color: styles.ButtonText,
        },
        desktopPlaceOrderButton: {
          borderRadius: '4px',
          lineHeight: '21px',
          fontSize: '16px',
          fontWeight: '600',
        },
        CommonColorTxt: {
          color: `${styles.CommonColor} !important`,
        },
        StatusPendingTxt: {
          color: `${styles.StatusPending} !important`,
        },
        LinkColorTxt: {
          color: `#0000dd !important`,
        },
        primaryColor: {
          color: "#ffffff !important",
        },
        alertInfoBackGround: {
          background: styles.CommonColor,
        },
        alertInfoBackGroundSushi: {
          background: "#787878",
        },
        TitleBar: {
          "background-color": styles.TitleBar,
        },
        nav: {
          "background-color": `${menuCategoriesBackground}`,
        },
        sushiNav: {
          "background-color": `#F04653`,
        },
        sushiBackground: {
          "background": `#89E9FF`,
        },
        navText: {
          color: styles.MenuText,
        },
        menu: {
          "background": MenuBackgroundString,
        },
        MenuHighlight: {
          "border-color": `${styles.MenuHighlight} !important`,
        },
        MenuHighlightedText: {
          color: `${styles.MenuHighlightedText} !important`,
        },
        primaryBodyBackground: {
          "background-color": `#eeeeee !important`,
        },
        CommonColorBackground: {
          "background-color": `${styles.CommonColor} !important`,
        },
        pendingStatusBackground: {
          "background-color": `${styles.StatusPending} !important`,
        },
        successMsg: {
          color: `#0275d8`,
          "border-color": `#0275d8`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        errorMsg: {
          color: `#E91E63`,
          "border-color": `#E91E63`,
          "border-width": "1px",
          "border-style": "solid",
          "border-radius": ".3rem",
        },
        roolIntoButton: {
          "border-color": "#0275d8",
          "border-width": "1px",
          "border-style": "solid",
          background: "#0275d8",
          color: "#ffffff",
          width: "100%",
        },
        stepProgressBarBeforeCommonColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `#212529`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `#212529`,
          "border-radius": "50%",
        },
        stepProgressBarBeforePendingColor: {
          content: "",
          display: "block",
          margin: "0px auto 4px",
          "background-color": `#ededed`,
          width: "30px",
          height: "30px",
          "line-height": "28px",
          "text-align": "center",
          "font-weight": "bold",
          "border-width": "2px",
          "border-style": "solid",
          "border-color": `#ededed`,
          "border-radius": "50%",
        },
        stepProgressBarAfterCommonColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `#212529`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1",
        },
        stepProgressBarAfterPendingColor: {
          content: "",
          height: "4px",
          width: "100%",
          "background-color": `#ededed`,
          position: "absolute",
          top: "12px",
          left: "50%",
          "z-index": "-1",
        },
      };
    },
    styles(state, getters) {
      let ismobile = DetectMobile.methods.isMobile();
      let res = ismobile ? getters.mobileStyles : getters.desktopStyles;
      let common = defaultCommonStyles();
      return { ...res, ...common };
    },
    activePopup(state) {
      return state.activePopup;
    },
    buttonStyles(state, getters) {
      let {background, border, color} = DetectMobile.methods.isMobile()
          ? getters.mobileStyles.btn
          : getters.desktopStyles.btn;

      background = background.toString().concat(' !important');
      border = border.toString().concat(' !important');
      color = color.toString().concat(' !important');

      return {background, border, color};
    },
  },
};
